<mat-card class="stepper">

  <div class="allStepWithBack">

    <button mat-flat-button color="primary" (click)="SubmitBackButton()" matTooltip="Back">
      Back
    </button>

    <div class="allSteps">
      <div [ngClass]="stepCompleted >0 ? 'active step done' : 'active step'">
        <div class="stepStatus" (click)="showUploadDocuments()">
          <span class="nmbr">1</span>
          <span class="stepName">Upload Document </span>
          <span class="stepIcon"><mat-icon>picture_as_pdf</mat-icon> </span>
        </div>
      </div>

      <div [ngClass]="stepCompleted >1 ? 'active step done' : 'active step'">
        <div class="stepStatus" (click)="showAllParticipant()">
          <span class="nmbr">2</span>
          <span class="stepName">Add Participant </span>
          <span class="stepIcon"><mat-icon>account_box</mat-icon> </span>
        </div>
      </div>

      <div [ngClass]="stepCompleted >2 ? 'active step done' : 'active step'">
        <div class="stepStatus" (click)="ShowForm()">
          <span class="nmbr">3</span>
          <span class="stepName">Design Form </span>
          <span class="stepIcon"><mat-icon>design_services</mat-icon> </span>
        </div>
      </div>

      <div [ngClass]="stepCompleted >3 ? 'active step done' : 'active step'">
        <div class="stepStatus">
          <span class="nmbr">4</span>
          <span class="stepName">Review & Send </span>
          <span class="stepIcon"> <mat-icon>send</mat-icon> </span>
        </div>
      </div>
    </div>

    <button class="spButton" *ngIf="typeFormOrTemp == 1" mat-flat-button color="primary" matTooltip="Finish"
      (click)="saveProject(saveTemp)">
      Finish
    </button>
    <button class="spButton" *ngIf="typeFormOrTemp == 2" mat-flat-button color="primary" matTooltip="Finish"
      (click)="saveTemplate(saveCopyTemp)">
      Finish
    </button>


  </div>



  <!-- <div class="stepAct">
   
    
  </div> -->
</mat-card>

<div class="formWrapper">
  <mat-card class="container">
    <div class="page_header">
      <div class="back"></div>
      <span>Review & Send</span>
    </div>

    <div class="step four stepFourTab" id="step4">

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Message">

          <div class="msgBlock">
            <label class="mt-5 mb-5" >Message to recipients</label>
            <mat-form-field>
              <mat-label>Add Subject</mat-label>
              <!-- <input matInput placeholder="Add Subject" #subjectadd
                (input)="onChangeSubject($event.target.value)" [(ngModel)]="subject" required/> -->

              <input matInput placeholder="Add or select subject" aria-label="State" [matAutocomplete]="auto1"
                #subjectadd (input)="searchSubject($event.target.value)" [formControl]="stateCtrlSubject"
                [(ngModel)]="subject" (keydown.enter)="onEnterSubject($event,'')" required>
              <mat-autocomplete #auto1="matAutocomplete">
                <mat-option (click)="subjectSelected(subject)" *ngFor="let subject of subjectList"
                  [value]="subject.subject">
                  <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                    <div class="info">
                      <p> {{ subject.subject }}</p>
                    </div>
                  </span>
                </mat-option>
              </mat-autocomplete>

            </mat-form-field>

            <mat-form-field>
              <mat-label>Add Message</mat-label>
              <textarea matInput placeholder="Write your message..." (input)="onChangeMessage($event.target.value)"
                [(ngModel)]="message"  rows="5" ></textarea>
            </mat-form-field>

            <button mat-button color="primary" *ngIf="ShowSubjectMessageButton" (click)="AddSubjectMessageTemplate()"
              [disabled]="SubjectMessageButton">Add Template
              <mat-icon *ngIf="spinnerTemp">
                <mat-spinner diameter="20">
                </mat-spinner>
              </mat-icon>
            </button>

          </div>

        </mat-tab>

        <mat-tab label="Documents">

          <div class="msgBlock" *ngIf="documentList.length > 0">
            <label class="mt-5 mb-5" >Documents
              <span class="edit" [routerLink]="'/esignature/first'">Edit</span>
            </label>

            <div class="fileHolder">
              <div class="example-box" *ngFor="let file of documentList">
                <mat-card class="fileCont">

                  <div class="Icon" *ngIf="file.fileType == 'pdf'">
                    <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                  </div>

                  <div class="Icon" *ngIf="file.fileType == 'jpg' || file.fileType == 'jpeg'">
                    <img src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
                  </div>

                  <div class="Icon" *ngIf="file.fileType == 'png' || file.fileType == 'gif' ||
                      file.fileType == 'tiff' || file.fileType == 'bmp'">
                    <img src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
                  </div>

                  <div class="nameInfo">
                    <h2>{{ file.documentName }}</h2>
                  </div>

                </mat-card>
              </div>
            </div>
          </div>

        </mat-tab>

        <mat-tab label="Participant">

          <div class="msgBlock" *ngIf="participantsList.length > 0">
            <label class="mt-5 mb-5">Paticipants
              <span class="edit" [routerLink]="'/esignature/second'">Edit</span>
            </label>

            <div class="groupHolder" *ngFor=" let p of participantsList">

              <div class="groupheading">

                <h2 *ngIf="p.groupType ==1">
                  <mat-icon>create</mat-icon>{{p.groupName}}
                </h2>
                <h2 *ngIf="p.groupType !=1">
                  <mat-icon>description</mat-icon>{{p.groupName}}
                </h2>
              </div>

              <div *ngIf="p.projGrpRelationParticipantList.length == 0" class="moveblock example-box">
                <p class="nocontent">No relationship added</p>
              </div>

              <div *ngFor="let p of p.projGrpRelationParticipantList" class="moveblock example-box">
                <div class="allUserinfo">

                  <div class="userInfo">

                    <div class="relCol">

                      <div class="Colrd" [ngStyle]="{'background-color': p.colourCode }">
                        <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                        <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                        <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                        <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                        <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                        <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
                      </div>

                      <div class="chipss">
                        <mat-chip-list>
                          <mat-chip> {{p.relationName}} </mat-chip>
                        </mat-chip-list>
                      </div>

                    </div>

                    <div class="selectContact" *ngIf="p.participantName || p.roleName || p.contactEmail">
                      <div class="userpic" *ngIf="p.participantImageURL">
                        <img [src]="p.participantImageURL" alt="" />
                      </div>

                      <div class="userpic" *ngIf="!p.participantImageURL">
                        <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                        <span class="shortName" *ngIf="p.contactID==0">
                          {{getShortName(p.contactEmail)}}</span>
                        <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span>
                      </div>

                      <div class="info">
                        <p *ngIf="p.participantName">{{ p.participantName }} </p>
                        <p *ngIf="p.contactID==0">{{ p.contactEmail }} </p>
                        <p *ngIf="p.roleName">{{ p.roleName }} </p>
                        <p class="emailID" *ngIf="p.participantEmail">{{ p.participantEmail }} </p>
                      </div>

                    </div>


                  </div>
                  <div class="Cancel">
                    <button mat-icon-button color="primary" (click)="OpenMessage(access,p)">
                      <mat-icon>add_comment</mat-icon>
                    </button>
                  </div>

                </div>
                <div *ngIf="p.message" class="privateMessage">
                  <p>Message: {{ p.message }}</p>
                  <div class="Cancel">
                    <button mat-icon-button (click)="deletePrivateMessage(p)">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Manage External Links">
          <div class="bottomBlock">

            <div class="header" (click)="toggleExternaLink()">
              <span>Manage External URL</span>
              <button mat-icon-button  ><mat-icon>keyboard_arrow_down</mat-icon></button>
            </div>

            <div class="content" [ngClass]="{'active': showContent}" >
              <mat-slide-toggle color="primary" (change)="change3rdPartyurl($event)" [checked]="isUrlParameterConfigured">
                3rd Party Url Accept Configuration
              </mat-slide-toggle>

              <div class="msgBlock party" *ngIf="isUrlParameterConfigured==true">
                <label>3rd Party Url Accept Configuration</label>

                <div class="">

                  <mat-form-field  appearance="fill" class="example-full-width">
                    <mat-label>Success URL</mat-label>
                    <input matInput placeholder="" (input)="onSuccessURLChange($event.target.value)"
                      [(ngModel)]="successUrl">
                  </mat-form-field>

                  <div *ngIf="showSuccessUrlMessage==true" style="color: red;">Invalid URL</div>

                  <mat-form-field appearance="fill"  class="example-full-width">
                    <mat-label>Decline URL</mat-label>
                    <input matInput  placeholder="" (input)="onDeclineURLChange($event.target.value)"
                      [(ngModel)]="declineUrl">
                  </mat-form-field>

                  <div *ngIf="showDeclineUrlMessage==true" style="color: red;">Invalid URL</div>

                  <div class="">

                    <div class="subtaskHolder">
                      <form [formGroup]="dynamicForm">
                        <div formArrayName="filters">
                          <div *ngFor="let filter of filtersFormArray.controls; let i = index;">

                            <div class="rep" [formGroupName]="i">

                              <mat-form-field appearance="" class="field">
                                <mat-label>System Field</mat-label>
                                <mat-select placeholder="Select" formControlName="fieldID">
                                  <mat-option *ngFor="let stat of coreDropdownList" [value]="stat.fieldID">
                                    {{ stat.fieldName }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>

                              <mat-form-field>
                                <mat-label>Parameter Name</mat-label>
                                <input matInput formControlName="parameterName" placeholder="" maxlength="50">
                                <!-- <input matInput formControlName="url" placeholder="" 
                                pattern="^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$"> -->
                              </mat-form-field>
                              <!-- <div *ngIf="filter.get('url').invalid && filter.get('url').touched">Invalid URL</div> -->
                              <button mat-icon-button class="remove" color="warn"
                                (click)="removeFilterFromFiltersFormArray(i,filter.value)">
                                <mat-icon>remove_circle_outline</mat-icon>
                              </button>

                            </div>
                          </div>

                          <button class="subtask" mat-icon-button color="primary"
                            (click)="addFilterToFiltersFormArray()">
                            <mat-icon>add</mat-icon>
                            <!-- Add Record -->
                          </button>

                        </div>
                      </form>
                    </div>

                  </div>


                </div>
              </div>
              <br>
              <br>
              <mat-slide-toggle color="primary" (change)="showAutoFill($event)" [checked]="isShowAutoFill">
                Show auto fill popup on Signature page load
              </mat-slide-toggle>

              <br>
              <br>
              <mat-slide-toggle color="primary" (change)="changeFormSelectionParameter($event)"
                [checked]="isConfigureFormParameter">
                Configure Form Selection Parameter
              </mat-slide-toggle>

              <div class="msgBlock party" *ngIf="isConfigureFormParameter==true">
                <div class="">

                  <div class="">

                    <div class="subtaskHolder">
                      <form [formGroup]="dynamicFormParameter">
                        <div formArrayName="filtersFormParameter">
                          <div *ngFor="let filter of filtersFormParameterArray.controls; let i = index;">

                            <div class="rep" [formGroupName]="i">

                              <mat-form-field>
                                <mat-label>Parameter Name</mat-label>
                                <input matInput formControlName="parameterName" placeholder="" maxlength="50">
                              </mat-form-field>

                              <mat-form-field>
                                <mat-label>Value</mat-label>
                                <input matInput formControlName="value" placeholder="" maxlength="200">
                              </mat-form-field>

                              <button mat-icon-button class="remove" color="warn"
                                (click)="removeFormParameterFromFiltersFormArray(i,filter.value)">
                                <mat-icon>remove_circle_outline</mat-icon>
                              </button>

                            </div>
                          </div>

                          <button class="subtask" mat-icon-button color="primary"
                            (click)="addFormParameterFiltersFormArray()">
                            <mat-icon>add</mat-icon>
                          </button>

                        </div>
                      </form>
                    </div>

                  </div>


                </div>
              </div>
            </div>

          </div>
        </mat-tab>

      </mat-tab-group>












    </div>
  </mat-card>
</div>

<ng-template #access>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>email</mat-icon></span>
    Private Message
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <mat-form-field>
      <mat-label>Add Message</mat-label>
      <textarea matInput placeholder="Write your message..."
        (input)="onChangeParticipantForMessage($event.target.value)" [(ngModel)]="messageRelationParticipant"
        style="min-height: 70px"></textarea>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!DoneButtonDisabled"
      (click)="sendMessageRelationParticipant()">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #success>
  <h2 mat-dialog-title>
    <span class=""></span>
    <button mat-icon-button (click)="closeSucess()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="success">
      <img src="../../../../assets/images/success.jpg" alt="" />
    </div>
    <div class="messagebtn">
      <h2>
        Successfully documents are sent for signature! <br />
        You will be get notifications as per progress.
      </h2>
      <button mat-flat-button color="primary" (click)="CreateNew()">Create New</button>
    </div>
  </mat-dialog-content>
</ng-template>

<ng-template #forms>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>folder</mat-icon></span> Select folder to
    save document

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>


    <div class="taskLocation">
      <span>Core</span>
      <mat-icon>keyboard_arrow_right</mat-icon>
      <span>Admission</span>
      <mat-icon>keyboard_arrow_right</mat-icon>
      <span>HR & Training</span>
    </div>

    <div class="drive mainLink">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20">
          <div class="folderName">
            <mat-icon>folder</mat-icon>
            <span class="flname">{{ node.name }}</span>
          </div>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
          <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror arrowIcon">
              {{treeControl.isExpanded(node) ? "arrow_drop_down" : "arrow_right"}}
            </mat-icon>
            <div class="folderName">
              <mat-icon>folder</mat-icon>
              <span class="flname">{{ node.name }}</span>
            </div>
          </div>
        </mat-tree-node>
      </mat-tree>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-button color="primary" (click)="sendSuccess(success)">
      Done
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #saveTemp>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>folder</mat-icon></span>
    Save Project/Template
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </h2>





  <!--div class="saveTemplate" *ngIf="HideSendSaveTemplate">
    <mat-radio-group color="primary" aria-label="Select an option">
      <mat-radio-button value="1" [checked]="isSendEnabled==true" [disabled]="!isSendEnabled"
        (change)="OnSelectaboutSaveTemplate('1')">Send Project</mat-radio-button>
        <mat-radio-button value="11" [disabled]="!isSendEnabled"
        (change)="OnSelectaboutSaveTemplate('11')">Save as Template</mat-radio-button-->


  <!-- was old comment <mat-radio-button value="2" [disabled]="!isSendEnabled" (change)="OnSelectaboutSaveTemplate('2')">Send and Save
        Template</mat-radio-button>
      <mat-radio-button value="3" [disabled]="!isSendEnabled" (change)="OnSelectaboutSaveTemplate('3')">Save Template
        Only</mat-radio-button>
      <mat-radio-button value="4" [disabled]="!isSendEnabled" *ngIf="showOrgnizationLevelCheckbox==true"
        (change)="OnSelectaboutSaveTemplate('4')">Save as Organization Template</mat-radio-button> till this old comment -->

  <!--/mat-radio-group>
  </div-->



  <!-- <div class="saveTemplate" *ngIf="!HideSendSaveTemplate">
    <mat-radio-group color="primary" aria-label="Select an option">
      <mat-radio-button value="3" [checked]="isSendEnabled==true" [disabled]="!isSendEnabled"
        (change)="OnSelectaboutSaveTemplate1('3')">Save as My Template</mat-radio-button>
      <mat-radio-button value="4" [disabled]="!isSendEnabled" *ngIf="showOrgnizationLevelCheckbox==true"
        (change)="OnSelectaboutSaveTemplate1('4')">Save as Organization Template</mat-radio-button>
    </mat-radio-group>
  </div> -->





  <mat-dialog-content class="mat-typography stepFourTab" *ngIf="showFormFolder==true">

    <mat-tab-group [(selectedIndex)]="TabIndex" mat-stretch-tabs="true" mat-align-tabs="start" (selectedTabChange)="onTabChange($event)">

      <mat-tab label="Send Project"  [disabled]="!HideSendSaveTemplate">

        <div class="sepBlock" *ngIf="aboutSaveTemplate == '1'" [ngClass]="{'split': SplitBlock }">
          <div class="block">
            <mat-form-field class="" appearance="fill">
              <mat-label>Project Name</mat-label>
              <input matInput type="text" maxlength="60" [(ngModel)]="projectName"
                (input)="onChangeProjectname($event.target.value)" required />
            </mat-form-field>

            <h3>
              Select folder to save the finished document
            </h3>

            <div class="taskLocation">
              <span (click)="breadCrumbMyDriveMainClick()">My Drive</span>
              <ng-container *ngFor="let m of breadCrumMenuFileManager ; let indx = index">
                <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
                <span>{{ m.label }}</span>
              </ng-container>
            </div>


            <div class="drive mainLink">
              <mat-tree [dataSource]="dataSourceFileManager" [treeControl]="treeControlFileManager">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
                  *matTreeNodeDef="let node ; let indx = index" matTreeNodePadding matTreeNodePaddingIndent="20">
                  <!-- use a disabled button to provide padding for tree leaf -->
                  <div class="folderName" (click)="getFileManagerFoldersdetails(node)">
                    <mat-icon *ngIf="node.isShared == false"
                      (click)="getFileManagerFoldersdetails(node)">folder</mat-icon>
                    <mat-icon *ngIf="node.isShared == true"
                      (click)="getFileManagerFoldersdetails(node)">folder_shared</mat-icon>
                    <span (click)="getFileManagerFoldersdetails(node)">{{ node.name }}</span>
                  </div>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
                  *matTreeNodeDef="let node;when: hasChild ; let indx = index" matTreeNodePadding
                  matTreeNodePaddingIndent="20">
                  <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                      {{ treeControl.isExpanded(node) ? "arrow_drop_down" : "arrow_right" }}
                    </mat-icon>
                    <div class="folderName" (click)="getFileManagerFoldersdetails(node)">
                      <mat-icon *ngIf="node.isShared == false"
                        (click)="getFileManagerFoldersdetails(node)">folder</mat-icon>
                      <mat-icon *ngIf="node.isShared == true"
                        (click)="getFileManagerFoldersdetails(node)">folder_shared</mat-icon>
                      <span (click)="getFileManagerFoldersdetails(node)">{{ node.name }}</span>
                    </div>
                  </div>
                </mat-tree-node>
              </mat-tree>
            </div>
          </div>
        </div>

      </mat-tab>

      <mat-tab label="Save as template">

        <div class="saveTemplate" *ngIf="showTemplateRadioButton==true">
          <mat-radio-group color="primary" aria-label="Select an option">

            <mat-radio-button value="2" [checked]="SendandSaveTemplateRadioButton==true" [disabled]="!HideSendSaveTemplate"
              (change)="OnSelectaboutSaveTemplate('2')">
              Send Project and Save Template</mat-radio-button>
            <mat-radio-button value="3" [checked]="SaveasMyTemplateRadioButton==true"  (change)="OnSelectaboutSaveTemplate('3')">
              Save as My Template</mat-radio-button>
            <mat-radio-button value="4" *ngIf="showOrgnizationLevelCheckbox==true"
              (change)="OnSelectaboutSaveTemplate('4')">
              Save as Organization Template</mat-radio-button>

          </mat-radio-group>
        </div>

        <ng-container *ngIf="aboutSaveTemplate == '2' || aboutSaveTemplate == '3'">
          <div class="sepBlock insavetemp" [ngClass]="{'split': SplitBlock }">
            <div class="block" *ngIf="aboutSaveTemplate != '3'">
              <mat-form-field class="" appearance="fill">
                <mat-label>Project Name</mat-label>
                <input matInput type="text" maxlength="60" [(ngModel)]="projectName"
                  (input)="onChangeProjectname($event.target.value)" required />
              </mat-form-field>
            </div>
            <div class="block">
              <mat-form-field class="" appearance="fill">
                <mat-label>Template Name</mat-label>
                <input matInput type="text" maxlength="60" [(ngModel)]="templateName"
                  (input)="onChangeTemplateName($event.target.value)" required />
              </mat-form-field>
            </div>

          </div>

        </ng-container>

        <ng-container *ngIf="aboutSaveTemplate == '2' || aboutSaveTemplate == '3'">
          <div *ngIf="isSharedWithMe!=true" class="sepBlock"
            [ngClass]="{'split': aboutSaveTemplate == '2' || aboutSaveTemplate == '3' }">
            <div class="block">

              <h3>
                Select folder to save the finished document
              </h3>

              <div class="taskLocation">
                <span (click)="breadCrumbMyDriveMainClick()">My Drive</span>
                <ng-container *ngFor="let m of breadCrumMenuFileManager ; let indx = index">
                  <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
                  <span>{{ m.label }}</span>
                </ng-container>
              </div>


              <div class="drive mainLink">
                <mat-tree [dataSource]="dataSourceFileManager" [treeControl]="treeControlFileManager">
                  <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
                    *matTreeNodeDef="let node ; let indx = index" matTreeNodePadding matTreeNodePaddingIndent="20">
                    <div class="folderName" (click)="getFileManagerFoldersdetails(node)">
                      <mat-icon *ngIf="node.isShared == false"
                        (click)="getFileManagerFoldersdetails(node)">folder</mat-icon>
                      <mat-icon *ngIf="node.isShared == true"
                        (click)="getFileManagerFoldersdetails(node)">folder_shared</mat-icon>
                      <span (click)="getFileManagerFoldersdetails(node)">{{ node.name }}</span>
                    </div>
                  </mat-tree-node>

                  <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
                    *matTreeNodeDef="let node;when: hasChild ; let indx = index" matTreeNodePadding
                    matTreeNodePaddingIndent="20">
                    <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                      <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                        {{ treeControl.isExpanded(node) ? "arrow_drop_down" : "arrow_right" }}
                      </mat-icon>
                      <div class="folderName" (click)="getFileManagerFoldersdetails(node)">
                        <mat-icon *ngIf="node.isShared == false"
                          (click)="getFileManagerFoldersdetails(node)">folder</mat-icon>
                        <mat-icon *ngIf="node.isShared == true"
                          (click)="getFileManagerFoldersdetails(node)">folder_shared</mat-icon>
                        <span (click)="getFileManagerFoldersdetails(node)">{{ node.name }}</span>
                      </div>
                    </div>
                  </mat-tree-node>
                </mat-tree>
              </div>
            </div>


            <div class="block">

              <h3>
                Select folder to save template
              </h3>

              <div class="taskLocation">
                <span (click)="breadCrumbMyFormsMainClick()">Forms</span>
                <ng-container *ngFor="let m of breadCrumMenu ; let indx = index">
                  <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
                  <span>{{ m.formFolderName }}</span>
                </ng-container>

              </div>

              <div class="drive mainLink">
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                  <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderName }"
                    *matTreeNodeDef="let node ; let indx = index" matTreeNodePadding matTreeNodePaddingIndent="20">

                    <div class="folderName" (click)="getFormFolderWithFormTemplates(node)">
                      <mat-icon *ngIf="node.isShared == false"
                        (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                      <mat-icon *ngIf="node.isShared == true"
                        (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                      <span (click)="getFormFolderWithFormTemplates(node)">{{ node.formFolderName }}</span>
                    </div>
                  </mat-tree-node>

                  <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderName }"
                    *matTreeNodeDef="let node;when: hasChild ; let indx = index" matTreeNodePadding
                    matTreeNodePaddingIndent="20">
                    <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
                      <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                        {{ treeControl.isExpanded(node) ? "arrow_drop_down" : "arrow_right" }}
                      </mat-icon>
                      <div class="folderName" (click)="getFormFolderWithFormTemplates(node)">
                        <mat-icon *ngIf="node.isShared == false"
                          (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                        <mat-icon *ngIf="node.isShared == true"
                          (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                        <span (click)="getFormFolderWithFormTemplates(node)">{{ node.formFolderName }}</span>
                      </div>
                    </div>
                  </mat-tree-node>
                </mat-tree>
              </div>
            </div>

          </div>
        </ng-container>

        <div class="cateAdd" *ngIf="aboutSaveTemplate == '4'">
          <mat-form-field class="">
            <mat-label>Select Template Category</mat-label>
            <mat-select (selectionChange)="SelectOrganizationCategoryType($event)">
              <mat-option *ngFor="let template of OrganizationLeveltemplateList" [value]="template.categoryID">
                {{ template.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-icon-button color="primary" (click)="AddOrgTemCatDialog()"> <mat-icon>add</mat-icon> </button>
         
        </div>

        <mat-form-field class="" appearance="fill"  *ngIf="aboutSaveTemplate == '4'">
          <mat-label>Template Name</mat-label>
          <input matInput type="text" maxlength="60" [(ngModel)]="templateName"
            (input)="onChangeTemplateName($event.target.value)" required />
        </mat-form-field>

      </mat-tab>

    </mat-tab-group>


  </mat-dialog-content>


  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!sendsavebuttonshow" (click)="sendSuccess(success)"
      *ngIf="aboutSaveTemplate == '1'">
      Send <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
    <button mat-flat-button color="primary" [disabled]="!sendsavebuttonshow" (click)="sendSuccess(success)"
      *ngIf="aboutSaveTemplate == '3' || aboutSaveTemplate == '4'">
      Save <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
    <button mat-flat-button color="primary" [disabled]="!sendsavebuttonshow" (click)="sendSuccess(success)"
      *ngIf="aboutSaveTemplate == '2'">
      Send <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>

  </mat-dialog-actions>
</ng-template>




<ng-template #saveCopyTemp>

  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>folder</mat-icon></span>
    Select Path
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </h2>
  <mat-dialog-content class="mat-typography">

    <div class="saveTemplate" *ngIf="!HideSendSaveTemplate">
      <mat-radio-group color="primary" aria-label="Select an option">
        <mat-radio-button value="3" [checked]="isSendEnabled==true" [disabled]="!isSendEnabled"
          (change)="OnSelectaboutSaveTemplate1('3')">Save as My Template</mat-radio-button>
        <mat-radio-button value="4" [disabled]="!isSendEnabled" *ngIf="showOrgnizationLevelCheckbox==true"
          (change)="OnSelectaboutSaveTemplate1('4')">Save as Organization Template</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="cateAdd" *ngIf="showOrganizationTempCategory==true">
      <mat-form-field class="">
        <mat-label>Select Template Category</mat-label>
        <mat-select (selectionChange)="SelectOrganizationCategoryType($event)">
          <mat-option *ngFor="let template of OrganizationLeveltemplateList" [value]="template.categoryID">
            {{ template.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-icon-button color="primary" (click)="AddOrgTemCatDialog()"> <mat-icon>add</mat-icon> </button>

    </div>

    <div *ngIf="MasterTemplatePDFForm" class="cateAdd">
      <mat-form-field class="">
        <mat-label>Select Template Category</mat-label>
        <mat-select [(value)]="MasterTemplatecategoryID" (selectionChange)="SelectCategoryType($event)">
          <mat-option *ngFor="let template of CategoryTypeList" [value]="template.categoryID">
            {{ template.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-icon-button color="primary" (click)="openDialogForAddCategory()"> <mat-icon>add</mat-icon> </button>
    </div>

    <div *ngIf="MasterOrgTemplatePDFForm" class="cateAdd">
      <mat-form-field class="">
        <mat-label>Select Template Category</mat-label>
        <mat-select [(value)]="OrganizationCategoryId" (selectionChange)="SelectOrganizationCategoryType($event)">
          <mat-option *ngFor="let template of OrganizationLeveltemplateList" [value]="template.categoryID">
            {{ template.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-icon-button color="primary" (click)="AddOrgTemCatDialog()"> <mat-icon>add</mat-icon> </button>
    </div>

    <mat-form-field class="" appearance="fill">
      <mat-label>Template Name</mat-label>
      <input matInput type="text" maxlength="60" [(ngModel)]="templateName"
        (input)="onChangeTemplateName($event.target.value)" required />
    </mat-form-field>

    <div class="sepBlock" *ngIf="showFormFolder==true" [ngClass]="{'split': SplitBlock }">

      <div class="block">
        <h3>
          Select folder to save the finished document
        </h3>

        <div class="taskLocation">
          <span (click)="breadCrumbMyDriveMainClick()">My Drive</span>
          <ng-container *ngFor="let m of breadCrumMenuFileManager ; let indx = index">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <span>{{ m.label }}</span>
          </ng-container>
        </div>


        <div class="drive mainLink">
          <mat-tree [dataSource]="dataSourceFileManager" [treeControl]="treeControlFileManager">
            <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
              *matTreeNodeDef="let node ; let indx = index" matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderName" (click)="getFileManagerFoldersdetails(node)">
                <mat-icon *ngIf="node.isShared == false" (click)="getFileManagerFoldersdetails(node)">folder</mat-icon>
                <mat-icon *ngIf="node.isShared == true"
                  (click)="getFileManagerFoldersdetails(node)">folder_shared</mat-icon>
                <span (click)="getFileManagerFoldersdetails(node)">{{ node.name }}</span>
              </div>
            </mat-tree-node>

            <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
              *matTreeNodeDef="let node;when: hasChild ; let indx = index" matTreeNodePadding
              matTreeNodePaddingIndent="20">
              <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                  {{ treeControl.isExpanded(node) ? "arrow_drop_down" : "arrow_right" }}
                </mat-icon>
                <div class="folderName" (click)="getFileManagerFoldersdetails(node)">
                  <mat-icon *ngIf="node.isShared == false"
                    (click)="getFileManagerFoldersdetails(node)">folder</mat-icon>
                  <mat-icon *ngIf="node.isShared == true"
                    (click)="getFileManagerFoldersdetails(node)">folder_shared</mat-icon>
                  <span (click)="getFileManagerFoldersdetails(node)">{{ node.name }}</span>
                </div>
              </div>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>


      <div class="block">

        <h3>
          Select folder to save template
        </h3>

        <div class="taskLocation">
          <span (click)="breadCrumbMyFormsMainClick()">Forms</span>
          <ng-container *ngFor="let m of breadCrumMenu ; let indx = index">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <span>{{ m.formFolderName }}</span>
          </ng-container>

        </div>

        <div class="drive mainLink">
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderName }"
              *matTreeNodeDef="let node ; let indx = index" matTreeNodePadding matTreeNodePaddingIndent="20">

              <div class="folderName" (click)="getFormFolderWithFormTemplates(node)">
                <mat-icon *ngIf="node.isShared == false"
                  (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                <mat-icon *ngIf="node.isShared == true"
                  (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                <span (click)="getFormFolderWithFormTemplates(node)">{{ node.formFolderName }}</span>
              </div>
            </mat-tree-node>

            <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderName }"
              *matTreeNodeDef="let node;when: hasChild ; let indx = index" matTreeNodePadding
              matTreeNodePaddingIndent="20">
              <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
                <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                  {{ treeControl.isExpanded(node) ? "arrow_drop_down" : "arrow_right" }}
                </mat-icon>
                <div class="folderName" (click)="getFormFolderWithFormTemplates(node)">
                  <mat-icon *ngIf="node.isShared == false"
                    (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                  <mat-icon *ngIf="node.isShared == true"
                    (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                  <span (click)="getFormFolderWithFormTemplates(node)">{{ node.formFolderName }}</span>
                </div>
              </div>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>

    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="SaveTemplateButton" (click)="SaveTemplate(success)">
      Save
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>
</ng-template>